import React from "react";
import { LOGO_URL } from "../../lib/api";
import { ShieldCheck, LogIn } from "lucide-react";

export default function AdminLogin() {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B132B] px-5">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-[#1C2541] p-10 text-center text-white">
        <img src={LOGO_URL} alt="Helping Hands" className="mx-auto h-16 w-16 rounded-full object-cover ring-1 ring-gold/40" />
        <h1 className="mt-5 font-display text-3xl font-bold">Helping Hands Admin</h1>
        <p className="mt-2 text-sm text-emerald-100/60">Secure, role-based access for authorised staff only.</p>
        <button onClick={login} data-testid="google-login-btn" className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-bold text-white transition hover:bg-gold-light">
          <LogIn className="h-4 w-4" /> Sign in with Google
        </button>
        <p className="mt-6 flex items-center justify-center gap-2 text-xs text-emerald-100/50"><ShieldCheck className="h-3.5 w-3.5" /> 2FA-ready · Audit-logged · Encrypted sessions</p>
      </div>
    </div>
  );
}
